import * as React from "react";
import { forwardRef } from "react";
const SpeechBubbleSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { d: "M15 8c0 3.314-3.134 6-7 6a8 8 0 0 1-2-.248c-.74-.19-2.34.89-3.092 1.44-.147.107-.361-.018-.339-.198.117-.935.307-2.873-.069-3.282C1.56 10.69 1 9.402 1 8c0-3.314 3.134-6 7-6s7 2.686 7 6" }));
const ForwardRef = forwardRef(SpeechBubbleSVG);
export default ForwardRef;
//# sourceMappingURL=SpeechBubble.js.map